import React  from "react";
import { useParams } from 'react-router-dom';
import TimeCardForm from "./components/TimeCardDetails";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";

const ViewTimeCard = () => {
	const { cardId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<TimeCardForm recordId={cardId} mode="view"/>
	      	</div>
	    </div>
    );
};

export default ViewTimeCard;